
import React from 'react';
import { Link } from 'react-router-dom';
import { useLogoUrl } from '@/hooks/useLogoUrl';

interface HeaderBrandingProps {
  isMasterAdmin: boolean;
  isMasterLicenseRoute: boolean;
  brandName?: string;
}

const HeaderBranding: React.FC<HeaderBrandingProps> = ({ 
  isMasterAdmin, 
  isMasterLicenseRoute,
  brandName 
}) => {
  const logoUrl = useLogoUrl();
  const imageClassName = "block w-full h-auto max-h-20 md:max-h-24 object-contain";
  
  return (
    <Link to="/" className="block flex-shrink-0 w-56 md:w-72 lg:w-80" aria-label="ReferMe home">
      {logoUrl ? (
        <img
          src={logoUrl}
          alt="ReferMe.site"
          className={imageClassName}
        />
      ) : (
        <div className="flex items-center">
          <img
            src="/assets/referme-logo.png"
            alt="ReferMe.site"
            className={imageClassName}
          />
          {(isMasterAdmin || isMasterLicenseRoute) && (
            <h1 className="text-xl font-bold ml-2 text-white">Master License Portal</h1>
          )}
        </div>
      )}
    </Link>

  );
};

export default HeaderBranding;
